import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const AuthService = {
  async register(payload, { inviteToken } = {}) {
    const normalizedPayload =
      inviteToken && payload && typeof payload === "object"
        ? { ...payload, inviteToken }
        : payload;

    return safeRequest(
      apiClient
        .post("/auth/register", normalizedPayload)
        .then((response) => response.data),
    );
  },

  async login(payload, { inviteToken } = {}) {
    const config = inviteToken ? { params: { inviteToken } } : undefined;
    return safeRequest(
      apiClient
        .post("/auth/login", payload, config)
        .then((response) => response.data),
    );
  },

  async patchPassword(payload) {
    return safeRequest(
      apiClient
        .patch("/auth/password", payload)
        .then((response) => response.data),
    );
  },
};
